export type { ImageQuestionProps } from "./ImageQuestion";
export { default } from "./ImageQuestion";
export { ImageQuestionWrap } from "./styles";
